var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44706 10.7344L1.5278 10.5122L1.40731 10.3088C0.822806 9.3221 0.50984 8.19819 0.500228 7.05128C0.490616 5.90438 0.784701 4.77538 1.35259 3.77901C1.92047 2.78264 2.74191 1.95442 3.73342 1.3785C4.72492 0.802583 5.85116 0.499487 6.99769 0.500001L6.99821 0.500001C7.99813 0.499412 8.9847 0.729668 9.88112 1.17285C10.7775 1.61603 11.5596 2.26019 12.1665 3.05518C12.7734 3.85018 13.1886 4.77455 13.38 5.75636C13.5713 6.73816 13.5335 7.75088 13.2696 8.71569C13.0056 9.68049 12.5226 10.5713 11.8582 11.3189C11.1938 12.0664 10.3659 12.6505 9.43896 13.0256C8.51202 13.4007 7.51103 13.5568 6.51394 13.4816C5.51684 13.4065 4.55052 13.1022 3.69021 12.5924L3.48669 12.4718L3.26437 12.5527L0.684621 13.4913C0.684432 13.4913 0.684244 13.4914 0.684055 13.4915C0.668533 13.497 0.652205 13.4999 0.63574 13.5C0.614141 13.4999 0.59287 13.4946 0.573689 13.4846C0.55429 13.4745 0.5376 13.4598 0.525043 13.4419C0.512481 13.4239 0.504425 13.4032 0.501566 13.3814C0.498707 13.3597 0.501131 13.3376 0.50863 13.317L0.508699 13.3168L1.44706 10.7344Z",
    stroke: "#2B2B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.e6c09f34c25cc34f3b806e87b5bb62c7.svg";
export { ForwardRef as ReactComponent };